import type { RuntimeAnswer } from '../../types/runtime';

interface Props {
  answer: RuntimeAnswer;
}

export function MatterSummaryCard({ answer }: Props) {
  return (
    <article className="rounded-lg border border-emerald-200 bg-emerald-50 p-4 text-sm text-emerald-900">
      <div className="mb-2 flex items-center gap-2">
        <span className="rounded bg-emerald-200 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide">
          Matter summary
        </span>
        {answer.matter_number && (
          <span className="text-xs text-emerald-800">{answer.matter_number}</span>
        )}
      </div>
      <p className="whitespace-pre-line leading-relaxed">{answer.content}</p>
    </article>
  );
}
